
const evnMap = [
  { message: 'Einzelverbindungsnachweis mit vollständiger Zielrufnummer', key: 'ALL' },
  { message: 'Einzelverbindungsnachweis mit gekürzter Zielrufnummer', key: 'ANO' },
  { message: 'Kein Einzelverbindungsnachweis', key: 'NOT' }
]
export { evnMap }
